import React from "react";

import Button from "@material-ui/core/Button";
import IconButton from "@material-ui/core/IconButton"
import DeleteIcon from '@material-ui/icons/Delete';

import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogActions from "@material-ui/core/DialogActions";
import {Grid} from "@material-ui/core";

export type Attention = {
  message: string | React.ReactNode,
  style: object,
}

export const DeleteButton: React.FC<{ handleDelete: () => void, title?: string, text?: string, attention?: Attention }> = (props) => {
  const [open, setOpen] = React.useState(false);
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const title = props.title ? props.title : "削除";
  const text = props.text ? props.text : "削除しますか？";

  return (
    <React.Fragment>
      <IconButton aria-label="delete" onClick={handleClickOpen}>
        <DeleteIcon/>
      </IconButton>
      <Dialog
        open={open}
        onClose={handleClose}
      >
        <DialogTitle>{title}</DialogTitle>
        <DialogContent>
          <DialogContentText>
            <Grid container spacing={3}>
              <React.Fragment>
                <Grid item xs={12}>
                  {text}
                </Grid>
                {props.attention &&
                <Grid item xs={12} style={props.attention?.style}>
                  {props.attention?.message}
                </Grid>
                }
              </React.Fragment>
            </Grid>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            キャンセル
          </Button>
          <Button
            onClick={() => {
              handleClose();
              props.handleDelete();
            }}
            color="primary"
            autoFocus
          >
            削除
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  )
}

